<template>
    <div class="card-body">

        <title-header title="Diretoria"></title-header>


        <div class="cards-content">

            <!--AMAURI SÉRGIO MORTÁGUA-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/AMAURI_SERGIO_MORTAGUA.jpeg" alt="Amauri">
                    </div>
                    <figcaption>
                        <h3>Amauri Sérgio Mortágua</h3>
                        <strong>Presidente</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>Amauri Sérgio Mortágua</h3>
                    <strong>Presidente</strong>
<!--                    <p>Presidente do Sindicato dos Comerciários de Tupã e Região e vereador.</p>-->
                </div>
            </div>

            <!--APARECIDO DE JESUS BRUZARROSCO-->

            <div class="card-diretor">
                <figure>
                    <div class="image">
                        <img
                            src="../../../../../img/diretoria/APARECIDO_DE_JESUS_BRUZARROSCO.jpg"
                            alt="APARECIDO DE JESUS BRUZARROSCO"
                        >
                    </div>
                    <figcaption>
                        <h3>APARECIDO DE JESUS BRUZARROSCO</h3>
                        <strong>1º VICE-PRESIDENTE</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>APARECIDO DE JESUS BRUZARROSCO </h3>
                    <strong>1º VICE-PRESIDENTE</strong>
                    <!--<p>Diretor de relações institucionais/sindicais, imprensa e comunicação do Sindicato dos Trabalhadores em Telemarketing.</p>-->
                </div>
            </div>

            <!--EDNA ALVES-->

            <div class="card-diretor">
                <figure>
                    <div class="image">
                        <img src="../../../../../img/diretoria/EDNA_ALVES.jpg" alt="Edna">
                    </div>
                    <figcaption>
                        <h3>EDNA ALVES</h3>
                        <strong>2º VICE-PRESIDENTE</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>EDNA ALVES</h3>
                    <strong>2º VICE-PRESIDENTE</strong>
                    <!--                    <p>Presidente do Sindicato dos Empregados em Estabelecimentos de Saúde de Jaú.</p>-->
                </div>
            </div>

            <!--ANTÔNIO ROGÉRIO MAGRI-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/ANTONIO_ROGERIO_MAGRI.jpeg" alt="ANTÔNIO ROGÉRIO MAGRI">
                    </div>
                    <figcaption>
                        <h3>ANTÔNIO ROGÉRIO MAGRI</h3>
                        <strong>SECRETÁRIO</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>ANTÔNIO ROGÉRIO MAGRI</h3>
                    <strong>SECRETÁRIO</strong>
<!--                    <p>Ex-Ministro do trabalho</p>-->
                </div>
            </div>

            <!--MARCOS MILANEZ RODRIGUES-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img
                            src="../../../../../img/diretoria/MARCOS_MILANEZ_RODRIGUES.jpg"
                            alt="MARCOS MILANEZ RODRIGUES"
                        >
                    </div>
                    <figcaption>
                        <h3>MARCOS MILANEZ RODRIGUES</h3>
                        <strong>SECRETÁRIO ADJUNTO</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>MARCOS MILANEZ RODRIGUES</h3>
                    <strong>SECRETÁRIO ADJUNTO</strong>
                    <!--                    <p>Presidente da Federação dos Comerciários do Estado de São Paulo e Deputado Federal.</p>-->
                </div>
            </div>

            <!--ROGÉRIO JOSÉ GOMES CARDOSO-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/ROGERIO_JOSE_GOMES_CARDOSO.jpg" alt="Rogério">
                    </div>
                    <figcaption>
                        <h3>ROGÉRIO JOSÉ GOMES CARDOSO</h3>
                        <strong>TESOUREIRO</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>ROGÉRIO JOSÉ GOMES CARDOSO</h3>
                    <strong>TESOUREIRO</strong>
<!--                    <p>Presidente da Federação dos Empregados em Turismo e Hospitalidade do Estado de São Paulo.</p>-->
                </div>
            </div>

            <!--JONATHAN FALEIROS-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/JONATHAN_FALEIROS.jpg" alt="Jonathan">
                    </div>
                    <figcaption>
                        <h3>JONATHAN FALEIROS</h3>
                        <strong>TESOUREIRO-ADJUNTO</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>JONATHAN FALEIROS</h3>
                    <strong>TESOUREIRO-ADJUNTO</strong>
<!--                    <p>Presidente do Sindicado dos Comerciários de Sertãozinho.</p>-->
                </div>
            </div>

            <!--DÉBORA FERREIRA MACHADO-->

            <div class="card-diretor">
                <figure>
                    <div class="image">
                        <img src="../../../../../img/diretoria/DEBORA_FERREIRA_MACHADO.jpg" alt="Débora">
                    </div>
                    <figcaption>
                        <h3>DÉBORA FERREIRA MACHADO</h3>
                        <strong>DIRETORA DA MULHER</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>DÉBORA FERREIRA MACHADO</h3>
                    <strong>DIRETORA DA MULHER</strong>
<!--                    <p>Diretora de Imprensa e Comunicação Social do Sindicato dos Bancários de São José dos Campos e-->
<!--                        Região.</p>-->
                </div>
            </div>

            <!--SANTA REGINA PESSOTI ZAGRETTI-->

            <div class="card-diretor">
                <figure>
                    <div class="image">
                        <img
                            src="../../../../../img/diretoria/SANTA_REGINA_PESSOTI_ZAGRETTI.jpg"
                            alt="SANTA REGINA PESSOTI ZAGRETTI">
                    </div>
                    <figcaption>
                        <h3>SANTA REGINA PESSOTI ZAGRETTI</h3>
                        <strong>DIRETOR DE RELAÇÕES INTERNACIONAIS</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>SANTA REGINA PESSOTI ZAGRETTI</h3>
                    <strong>DIRETOR DE RELAÇÕES INTERNACIONAIS</strong>
                    <!--                    <p>Presidente do Sindicato dos Bancários de Tupã.</p>-->
                </div>
            </div>

            <!--KASMERE BEZERRA DE SOUSA-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/KASMERE_BEZERRA.jpg" alt="Kasmere">
                    </div>
                    <figcaption>
                        <h3>KASMERE BEZERRA DE SOUSA</h3>
                        <strong>DIRETOR DE ORGANIZAÇÃO E POLÍTICAS SIND. E ASSOCIATIVAS</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>KASMERE BEZERRA DE SOUSA</h3>
                    <strong>DIRETOR DE ORGANIZAÇÃO E POLÍTICAS SIND. E ASSOCIATIVAS</strong>
<!--                    <p>Secretária da Mulher do Sindicato dos Motoristas e Trabalhadores em Transporte Rodoviário Urbano-->
<!--                        do Estado de São Paulo.</p>-->
                </div>
            </div>

            <!--JAIR FRANCISCO MAFRA-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img
                            src="../../../../../img/diretoria/JAIR_FRANCISCO_MAFRA.jpg"
                            alt="JAIR_FRANCISCO_MAFRA"
                        >
                    </div>
                    <figcaption>
                        <h3>JAIR FRANCISCO MAFRA</h3>
                        <strong>DIRETOR DE ASSUNTOS JURÍDICOS </strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>JAIR FRANCISCO MAFRA</h3>
                    <strong>DIRETOR DE ASSUNTOS JURÍDICOS </strong>
                    <!--                    <p>Diretor-executivo do Sindicato dos Motoristas e Trabalhadores em Transporte Rodoviário Urbano do Estado de São Paulo.</p>-->
                </div>
            </div>

            <!--EDSON ANDRÉ DOS SANTOS FILHO-->

            <div class="card-diretor">
                <figure>
                    <div class="image">
                        <img src="../../../../../img/diretoria/EDSON_ANDRE_DOS_SANTOS_FILHO.jpg" alt="Edson">
                    </div>
                    <figcaption>
                        <h3>EDSON ANDRÉ DOS SANTOS FILHO</h3>
                        <strong>DIRETOR DE FORMAÇÃO E QUALIFICAÇÃO</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>EDSON ANDRÉ DOS SANTOS FILHO</h3>
                    <strong>DIRETOR DE FORMAÇÃO E QUALIFICAÇÃO</strong>
<!--                    <p>Tesoureiro-geral do Sindicato dos Trabalhadores em Empresas de Prestação de Serviços de Asseio e-->
<!--                        Conservação e Limpeza Urbana de São Paulo.</p>-->
                </div>
            </div>

            <!--MARCÍSIO MENDES DE MOURA-->

<!--            <div class="card-diretor">-->
<!--                <figure>-->
<!--                    <div class="image">-->
<!--                        <img-->
<!--                            src="../../../../../img/diretoria/MARCISIO_MENDES_DE_MOURA.jpg"-->
<!--                            alt="MARCÍSIO MENDES DE MOURA"-->
<!--                        >-->
<!--                    </div>-->
<!--                    <figcaption>-->
<!--                        <h3>MARCÍSIO MENDES DE MOURA</h3>-->
<!--                        <strong>DIRETOR DE COMUNICAÇÃO E IMPRENSA </strong>-->
<!--                    </figcaption>-->
<!--                </figure>-->
<!--                <div class="diretor-info">-->
<!--                    <h3>MARCÍSIO MENDES DE MOURA</h3>-->
<!--                    <strong>DIRETOR DE COMUNICAÇÃO E IMPRENSA </strong>-->
<!--&lt;!&ndash;                    <p>Diretor de relações institucionais/sindicais, imprensa e comunicação do Sindicato dos Trabalhadores em Telemarketing.</p>&ndash;&gt;-->
<!--                </div>-->
<!--            </div>-->

            <!--DANIELA DE SOUSA BITENCOURT DIAS-->

            <div class="card-diretor">
                <figure>
                    <div class="image">
                        <img src="../../../../../img/diretoria/DANIELA_GOME_DE_SOUSA.jpg" alt="Daniela">
                    </div>
                    <figcaption>
                        <h3>DANIELA DE SOUSA BITENCOURT DIAS</h3>
                        <strong>DIRETORA DA JUVENTUDE</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>DANIELA DE SOUSA BITENCOURT DIAS</h3>
                    <strong>DIRETORA DA JUVENTUDE</strong>
<!--                    <p>Diretora suplente do Sindicato dos Trabalhadores em Empresas de Prestação de Serviços de Asseio e-->
<!--                        Conservação e Limpeza Urbana de São Paulo.</p>-->
                </div>
            </div>

            <!--ANTÔNIO MARCO DOS SANTOS-->

            <div class="card-diretor">
                <figure>
                    <div class="image">
                        <img src="../../../../../img/diretoria/ANTONIO_MARCO_DOS_SANTOS.jpg" alt="Antônio">
                    </div>
                    <figcaption>
                        <h3>ANTÔNIO MARCO DOS SANTOS</h3>
                        <strong>DIRETOR DE RELAÇÕES POLÍTICAS E INSTITUCIONAIS</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>ANTÔNIO MARCO DOS SANTOS</h3>
                    <strong>DIRETOR DE RELAÇÕES POLÍTICAS E INSTITUCIONAIS</strong>
<!--                    <p>Presidente do Sindicato dos Empregados em Postos de Serviços em Combustível e Derivados de-->
<!--                        Petróleo de São José do Rio Preto.</p>-->
                </div>
            </div>

            <!--ARISTEU CARRIEL-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/ARISTEU_CARRIEL.jpg" alt="Aristeu">
                    </div>
                    <figcaption>
                        <h3>ARISTEU CARRIEL</h3>
                        <strong>DIRETOR DE ASSUNTOS DE DIVERSIDADE HUMANA E DE GÊNERO</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>ARISTEU CARRIEL</h3>
                    <strong>DIRETOR DE ASSUNTOS DE DIVERSIDADE HUMANA E DE GÊNERO</strong>
                    <!--                    <p>Presidente da subsede de Marília do Sindicato dos Empregados em Estabelecimentos de Serviços de Saúde.</p>-->
                </div>
            </div>

            <!--ELIANA ZOTESSO RAMOS-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/ELIANA_ZOTESSO_RAMOS.jpg" alt="Eliana">
                    </div>
                    <figcaption>
                        <h3>ELIANA ZOTESSO RAMOS</h3>
                        <strong>DIRETOR EXECUTIVO</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>ELIANA ZOTESSO RAMOS</h3>
                    <strong>DIRETOR EXECUTIVO</strong>
                    <!--                    <p>Presidente do Sindicato dos Trabalhadores Rurais de Novo Horizonte.</p>-->
                </div>
            </div>

        </div>

        <title-header title="Conselho Fiscal da UGT-SP" class="mt-12"></title-header>

        <div class="cards-content">

            <!--ROSANA MARIA ALARCON-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/ROSANA_MARIA_ALARCON.jpg" alt="Rosana">
                    </div>
                    <figcaption>
                        <h3>ROSANA MARIA ALARCON</h3>
                        <strong>EFETIVO CONSELHO FISCAL</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>ROSANA MARIA ALARCON</h3>
                    <strong>EFETIVO CONSELHO FISCAL</strong>
<!--                    <p>Presidente do Sindicato dos Comerciários de Fernandópolis.</p>-->
                </div>
            </div>

            <!--CÉLIA REGINA ALVES CASTELLO FOLHAS DAMAS-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/CELIA_REGINA_ALVES_CASTELLO_FOLHAS_DAMAS.jpg"
                             alt="Célia">
                    </div>
                    <figcaption>
                        <h3>CÉLIA REGINA ALVES CASTELLO FOLHAS DAMAS</h3>
                        <strong>EFETIVO CONSELHO FISCAL</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>CÉLIA REGINA ALVES CASTELLO FOLHAS DAMAS</h3>
                    <strong>EFETIVO CONSELHO FISCAL</strong>
<!--                    <p>Diretora do Sindicato dos Bancários de Franca.</p>-->
                </div>
            </div>

            <!--LUIZ CARLOS VERGARA PEREIRA-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/LUIZ_CARLOS_VERGARA.jpg" alt="Luiz Vergara">
                    </div>
                    <figcaption>
                        <h3>LUIZ CARLOS VERGARA PEREIRA</h3>
                        <strong>EFETIVO CONSELHO FISCAL </strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>LUIZ CARLOS VERGARA PEREIRA</h3>
                    <strong>EFETIVO CONSELHO FISCAL </strong>
<!--                    <p>Diretor da Federação dos Trabalhadores em Saúde do Estado de São Paulo.</p>-->
                </div>
            </div>

            <!--PAULO CÉSAR DA SILVA-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/PAULO_CESAR_DA_SILVA.jpg" alt="Paulo Cesar">
                    </div>
                    <figcaption>
                        <h3>PAULO CESAR DA SILVA</h3>
                        <strong>SUPLENTE CONSELHO FISCAL</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>PAULO CESAR DA SILVA</h3>
                    <strong>SUPLENTE CONSELHO FISCAL</strong>
<!--                    <p>Presidente do Sindicato dos Comerciários de Limeira.</p>-->
                </div>
            </div>

            <!--CARLOS ROBERTO LOPES BUENO-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/CARLOS_ROBERTO_LOPES_BUENO.jpg" alt="Weber Matias">
                    </div>
                    <figcaption>
                        <h3>CARLOS ROBERTO LOPES BUENO</h3>
                        <strong>SUPLENTE CONSELHO FISCAL</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>CARLOS ROBERTO LOPES BUENO</h3>
                    <strong>SUPLENTE CONSELHO FISCAL</strong>
                    <!--                    <p>Diretor do Sindicato dos Profissionais em Educação Física de São Paulo.</p>-->
                </div>
            </div>

            <!--GILBERTO LÚCIO ZANGIROLAMI-->

            <div class="card-diretor">
                <figure class="effect">
                    <div class="image">
                        <img src="../../../../../img/diretoria/GILBERTO_LUCIO_ZANGIROLAMI.jpg" alt="Gilberto">
                    </div>
                    <figcaption>
                        <h3>GILBERTO LUCIO ZANGIROLAMI</h3>
                        <strong>SUPLENTE CONSELHO FISCAL</strong>
                    </figcaption>
                </figure>
                <div class="diretor-info">
                    <h3>GILBERTO LUCIO ZANGIROLAMI</h3>
                    <strong>SUPLENTE CONSELHO FISCAL</strong>
<!--                    <p>1º Secretário do Sindicato dos Trabalhadores nas Indústrias de Construção e Mobiliário de-->
<!--                        Presidente Prudente.</p>-->
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'diretoria',
}
</script>


<style lang="scss" scoped>
.card-body {
    @apply p-20 pt-0;
    @media (max-width: 668px) {
        @apply p-8;
    }

    .cards-content {
        @apply grid gap-24 grid-cols-3;

        @media (max-width: 768px) {
            @apply gap-16 grid-cols-2 justify-items-center;
        }

        @media (max-width: 668px) {
            @apply gap-8 grid-cols-1;
        }

        .card-diretor {
            @apply shadow-2xl w-full max-w-md;

            figure {
                @apply w-full relative;


                .image {
                    @apply bg-black;

                    img {
                        @apply h-full;
                        max-height: 25rem;
                        opacity: 0.9;
                        -webkit-transition: opacity 0.35s;
                        transition: opacity 0.35s;
                    }
                }

                figcaption {
                    @apply flex flex-col items-center justify-center absolute top-0 bottom-0 right-0 left-0 opacity-0 text-white;

                    -webkit-backface-visibility: hidden;
                    backface-visibility: hidden;

                    h3 {
                        @apply text-sm font-bold uppercase px-3 text-center;
                    }

                    strong {
                        @apply text-xs font-light uppercase px-3 text-center;
                    }

                    p {
                        @apply flex items-center justify-center mt-4;

                        span {
                            @apply ml-2;
                        }
                    }
                }

                &:focus figcaption,
                &:hover figcaption {
                    @apply opacity-100;
                }

                &:focus .image img,
                &:hover .image img {
                    @apply opacity-25;
                }

            }

            .diretor-info {

                @apply flex flex-col justify-center items-center p-4;

                h3 {
                    @apply text-sm font-bold uppercase px-3 text-center;
                }

                strong {
                    @apply text-xs font-light uppercase px-3 text-center;
                }

                p {
                    @apply text-xs text-center mt-2 px-3;
                }
            }
        }
    }
}
</style>
